import React from "react";
import { Header } from "../../components/feature/Header";
import { Footer } from "../../components/feature/Footer";
import { Hero } from "./components/Hero";
import { TeamsPreview } from "./components/TeamsPreview";
import { ContactSection } from "./components/ContactSection";

export default function HomePage() {
  return (
    <>
      <Header />
      <Hero />
      <main>
        <TeamsPreview />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}
